const borderStyle = {
    root: {
        borderRadius: '10px',
    },
  };
  
  export default borderStyle;